import { render, staticRenderFns } from "./PhonolEnvNewEdit.vue?vue&type=template&id=cbe85dfe&scoped=true&"
import script from "./PhonolEnvNewEdit.vue?vue&type=script&lang=js&"
export * from "./PhonolEnvNewEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbe85dfe",
  null
  
)

export default component.exports